export const DRAWER_IDS = {
  ORGANIZATION: 'organization-drawer',
  CONTACT: 'contact-drawer',
  IMPORT: 'import-drawer',
  COURSE: 'course-drawer',
  USER: 'user-drawer',
  USER_DETAIL: 'user-detail-drawer',
  SUBSCRIPTION: 'subscription-drawer',
  STUDENT: 'student-drawer',
  MANAGE_ORG: 'manage-organization',
  ADMINISTRATOR: 'administrator-drawer',
  PREBIP: 'pre-bip-drawer',
  BIP: 'bip-drawer',
  PREBIP_DETAIL: 'pre-bip-detail-drawer',
  BIP_DETAIL: 'bip-detail-drawer',
  INCIDENT: 'incident-drawer',
  INCIDENT_UPDATE_DETAIL: 'incident-update-drawer',
  INCIDENT_DETAIL: 'incident-detail-drawer',
  FBA: 'Funcutional Assessment',
  DEFINE_BEHAVIOR: 'define-behavior',
  BIP_MANGE_STUDENT_TEAM: 'manage-student-team',
  ADD_TEAM_MEMBER: 'add-team-member',
  STUDENT_ATTACHMENT: 'student-attachment',
  BIP_STUDENT_ATTACHMENT: 'bip-student-attachment',
  STUDENT_PROFILE_IMAGE: 'student-profile-image',
  TIME: 'custom-time',
  ADD_TIME: 'add-time',
  MANAGE_BEHAVIOR_STRATEGIES: 'manage-behavior-strategies',
  MANAGE_BEHAVIOR_STRATEGY_SELECTION: 'manage-behavior-strategy-selection',
  MANAGE_BEHAVIOR_STRATEGIES_DETAIL: 'manage-behavior-strategies-detail',
  CREATE_OWN_STRATEGY: 'create-own-strategy',
  MANAGE_DATA: 'manage-behavior-data',
  ENTER_DATA: 'enter-data',
  FREQUENCY: 'frequency-data',
  DURATION: 'set-duration',
  PARTIAL_INTERVAL: 'partial-interval',
  DATA_GRAPH: 'graph-data',
  DATA_GRAPH_TREATMENT_PHASE: 'graph-data-treatment-phase',
  ADD_DATA: 'add-data',
  TEMPLATE_LOGS: 'template-logs',
  TEMPLATE_LOGS_FILTER: 'template-logs-filters',
  STRATEGIES_FILTER_DRAWER: 'strategies-filter-drawer',
  TEMPLATE_LOGS_DETAIL: 'template-log-detail',
  EDIT_TEMPLATE: 'edit-template',
  ADD_TEMPLATE: 'add-template',
  REFERENCE_MATERIAL: 'reference-material',
  FAQ: 'faq',
  CREATE_ADMIN_STRATEGY: 'create-admin-strategy',
  DATA_LOG: 'data-log',
  DATA_LOGS_FILTER: 'data-log-filters',
  DATA_LOG_DETAIL: 'data-log-detail',
  INSIGHTS_ADMIN_FILTER: 'insights-admin-filter',
  MANAGE_USER_DETAILS: 'manage-user-details',
  MANAGE_EDIT_USER: 'manage-edit-user',
  MOVE_USERS_ORG: 'move-users-org',
  BIP_PRINT_OPTIONS: 'behavior-print-options-drawer',
  CASE_FEEDBACK: 'case-feedback',
  REPORT_MANAGER: 'report-manager',
  CREATE_REPORT: 'create-report',
  EDIT_REPORT: 'edit-report',
  NOTE_DRAWER: 'note-drawer',
  DEFAULT_NULL: 'default-null',
  FEDILITY_FILTER: 'fedility-filter',
  FEDILITY_CHECK_DRAWER: 'fidelity-check-drawer',
  FEDILITY_CHECK_EMAIL_TEAM_DRAWER: 'fidelity-check-email-team-drawer',
  FEDILITY_CHECK_CORRECTION_NEEDED_DRAWER:
    'fidelity-check-correction-needed-drawer',
  E_LEARING_REPORT_DATE_FILTER: 'e-learning-report-date-filter',
  BROADCAST: 'broadcast-drawer',
  BASELINE_PERMISSION_MANAGEMENT: 'baseline-permission-management-drawer',
  E_LEARNING_LEARNER_DETAIL: 'e-learning-learner-detail-drawer',
  VIEW_FEEDBACK_FORM: 'view-feedback',
  FEEDBACK_FORM: 'feedback',
  NOTIFICATION_SETTINGS: 'notification-settings-drawer',
  DATA_NOTES: 'data-notes-drawer',
  CASE_ATTACHMENT_QUESTIONNAIRE: 'case-attachment-questionnaire-drawer',
  AUDIT_LOGS_FILTER: 'audit-logs-filter-drawer',
  AUDIT_LOGS_LOGIN_DETAIL: 'audit-logs-login-detail-drawer',
  AUDIT_LOGS_ACTIVITY_DETAIL: 'audit-logs-activity-detail-drawer',
  ADD_SUPER_USER: 'add-super-user-drawer',
} as const;
